var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[_c('div',{ref:"$video"},[_vm._t("video")],2),(!_vm.played)?_vm._t("default",null,{"play":_vm.play}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }